import { Search } from '@mui/icons-material'
import { Box, TextField } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'

const SearchField = ({
  value,
  onChange,
  placeholder = 'Search...',
  className = ''
}) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.searchContainer} ${className}`} data-test='search-field-container'>
      <Search className={classes.searchIcon} />
      <TextField
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={classes.searchField}
        data-test='search-field-input'
        inputProps={{
          'aria-label': 'Search for skills or topics'
        }}
      />
    </Box>
  )
}

export default SearchField
